const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  tableContainer: {
    flex: 1
  }
}

export default styles
